import { STATS } from '@/lib/platforms';

export const StatTicker = () => {
  return (
    <div className="border-y border-white/10 bg-ink-900">
      <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10">
        {STATS.map((s) => (
          <div key={s.label} className="px-6 py-8 md:py-10">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-3">
              {s.label}
            </div>
            <div className="font-display text-3xl md:text-4xl text-cyan">
              {s.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatTicker;
